/**
 * Legacy photo lists of the quality cards (top-level fields of the project), shown and granted
 * only by the block project-quality-report-data. Must match `PROJECT_QUALITY_REPORT_PHOTO_FIELDS`
 * in apps/apolloserver (services/projectBlocks.ts).
 */
export const PROJECT_QUALITY_REPORT_PHOTO_FIELDS = [
  'isRoofAccessibleFromInsideAttachments',
  'properSleeveUsedAtRoofPenetrationAttachments',
  'underlaySealedWellAtCableEntryAttachments',
  'labelingOfStringLinesAttachments',
  'correctSelectionOfPvConnectorsOnStringCableAttachments',
  'cablesNeatlyLaidInsideBuildingAttachments',
  'surgeProtectionBoxProperlyWiredInstallSpdAtRoofEntryAttachments',
  'documentationProjectReportAvailableAttachments',
  'specialCustomerRequestsDocumentedAttachments',
  'tileTypeAndWidthDocumentedAttachments',
  'replacementTileInstalledAttachments',
  'lightningProtectionPresentAttachments',
  'eachRailSecuredWithMinTwoHooksAttachments',
  'distanceRoofHookToTile35mmAttachments',
  'minScrewDistanceToRafterEdge24mmAttachments',
  'overhangObservedAttachments',
  'moduleFieldProperlyGroundedAttachments',
  'minRailOverhangAfterEndClamp20mmAttachments',
  'distancesToRidgeEavesNotLessThan20cmAttachments',
  'moduleClampAreasObservedAttachments',
  'modulesNoDamagesDirtShadingAttachments',
  'moduleClampsProperlyTightenedAttachments',
  'breakthroughProperlySealedAttachments',
  'cableProperlyLaidInChimneyAttachments',
  'cablesLaidProtectedUnderTilesAttachments',
  'cableEntryOnRoofProperlyDoneAttachments',
  'cableLaidInProtectiveSleeveAgainstUvRadiationAttachments',
  'peCableProperlySecuredAttachments',
  'flatRoofLightningProtectionPresentAttachments',
  'properGroundingFlatRoofSystemAttachments',
  'ballastingAccordingToProjectReportAttachments',
  'minimumModuleBearingAreaMaintainedAttachments',
  'qFlatProperlyConnectedAttachments',
  'distanceToDisturbingSurfacesMaintainedAttachments',
  'modulesNoDamageDirtShadingAttachments',
  'correctSelectionOfPvConnectorsAttachments',
  'cableEntryDoneProperlyAttachments',
  'cablesProtectedFromUvAttachments',
  'stringCableLabelingAttachments',
  'pvSystemLabeledInOrAtDistributionBoardAttachments',
  'testReportAvailableWithAllMeasurementsAttachments',
  'rcdTypeB300maAvailableInMeterAreaAttachments',
  'ussWiredProperlyInCabinetAttachments',
  'ussBoxWiredProperlyAttachments',
  'bendingRadiiMaintainedAttachments',
  'correctWiringOfMateboxAttachments',
  'correctWiringOfBatteryAttachments',
  'allComponentsProperlyGroundedAttachments',
];
